<ion-header class="pr-20">
  <ion-toolbar color="light" class="pt-20">
    <ion-buttons slot="start">
      @if((currentStep$|async)>0){
      <ion-button (click)="showPrevStep()">
        <ion-icon slot="icon-only" name="chevron-back-outline" size="large"></ion-icon>
      </ion-button>
      }
    </ion-buttons>
    <ion-title>
      {{ 'APP.INSTALLATION.BUTTONS.START_CHARGING' | translate }}
    </ion-title>
    <ion-buttons slot="end">
      <ion-button color="dark" (click)="close()">
        <ion-icon slot="icon-only" name="close-outline" size="large"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" class="ion-padding">
  @if ((currentStep$|async)===0) {
  <div class="review">
    <div class="review__hero">
      @if (mainStateService.$selectedStation(); as station) {
      <span class="review__eyebrow">{{ 'APP.INSTALLATION.START_EYEBROW' | translate }}</span>
      <h2 class="review__title">{{ station.name }}</h2>
      }
      @if (mainStateService.$selectedConnector(); as connector) {
      <div class="review__chips">
        <span class="review__chip"><span class="review__chip-n">{{ connector?.name || connector.cpConnectorId }}</span>{{ 'INSTALLATION.CONNECTOR' | translate }}</span>
        @if (connector.plugTypes?.length) {
        <span class="review__chip">{{ connector.plugTypes.join(' · ') }}@if (connector.power) {<span class="review__chip-mut"> · {{ connector.power / 1000 | number:'1.0-1' }} kW</span>}</span>
        }
      </div>
      }
    </div>

    <div class="review__rule"></div>
    <div class="review__section">
      <p class="review__label">{{ 'APP.INSTALLATION.VEHICLE' | translate }}</p>
      <ion-grid class="review__cars">
        <ion-row>
          <ion-col size="6" *ngFor="let car of mainStateService.$userCars()">
            <app-car-button [name]="car.model.brand.name" [model]="car.model.name"
              [isSelected]="car.id === mainStateService.$selectedUserCarForSession()?.id" (carButtonEvent)="selectNewCar(car)">
            </app-car-button>
          </ion-col>
        </ion-row>
      </ion-grid>
      <button type="button" class="review__add-vehicle" (click)="addVehicle()">
        <ion-icon name="add-outline"></ion-icon>
        {{ 'BUTTONS.ADD_VEHICLE' | translate }}
      </button>
    </div>

    <div class="review__section">
      <p class="review__label">{{ 'INSTALLATION.TARIFF' | translate }}</p>
      <div class="review__tariff">{{ $tariffText() }}</div>
    </div>

    @if (mainStateService.$selectedInstallation()?.openingTimes) {
    <div class="review__section">
      <p class="review__label">{{ 'OPENING_HOURS.TITLE' | translate }}</p>
      <yf-opening-hours mode="full"></yf-opening-hours>
    </div>
    }

    @if (chargingBenefitsLoading$ | async) {
      <div class="review__section">
        <p class="review__label">{{ 'APP.INSTALLATION.BENEFITS.TITLE' | translate }}</p>
        <ion-item lines="none" class="benefits-loading">
          <ion-spinner slot="start" name="crescent"></ion-spinner>
          <ion-label>{{ 'APP.INSTALLATION.BENEFITS.LOADING' | translate }}</ion-label>
        </ion-item>
      </div>
    } @else {
      @if (chargingBenefits$ | async; as chargingBenefits) {
        @if (getVisibleSponsorships(chargingBenefits); as sponsorships) {
          @if (sponsorships.length) {
            <div class="review__section">
              <p class="review__label">{{ 'APP.INSTALLATION.BENEFITS.TITLE' | translate }}</p>
              <div class="benefits-description">
                {{ 'APP.INSTALLATION.BENEFITS.DESCRIPTION' | translate }}
              </div>
              @if (sponsorships.length > 1) {
                <div class="benefits-note">
                  {{ 'APP.INSTALLATION.BENEFITS.MULTIPLE_NOTE' | translate }}
                </div>
              }
              <div class="sponsorship-list">
                @for (sponsorship of sponsorships; track sponsorship.policyId || $index) {
                  <div class="sponsorship-item" [class.sponsorship-item--primary]="sponsorship.primary">
                    <div class="sponsorship-box">
                      <div class="sponsorship-main">
                        <div class="sponsorship-title">
                          {{ sponsorship.policyName || ('APP.INSTALLATION.BENEFITS.DEFAULT_POLICY_NAME' | translate) }}
                        </div>
                        @if (sponsorship.primary && sponsorships.length > 1) {
                          <div class="sponsorship-priority">
                            {{ 'APP.INSTALLATION.BENEFITS.PRIMARY_POLICY_NOTE' | translate }}
                          </div>
                        }
                      </div>
                      <ion-icon
                        class="sponsorship-status-icon"
                        [name]="sponsorship.applied ? 'checkmark-circle' : 'close-circle'"
                        [color]="sponsorship.applied ? 'success' : 'danger'"
                        [attr.aria-label]="sponsorshipStatusLabel(sponsorship)">
                      </ion-icon>
                    </div>
                    @if (hasCoverageRules(sponsorship)) {
                      <div class="sponsorship-coverage">
                        <div class="sponsorship-coverage-title">
                          {{ 'APP.INSTALLATION.BENEFITS.COVERAGE_TITLE' | translate }}
                        </div>
                        <div class="sponsorship-coverage-list">
                          @for (rule of sponsorship.coverageRules; track rule.id || rule.componentType || $index) {
                            <ion-chip>
                              <ion-label>{{ sponsorshipCoverageText(rule) }}</ion-label>
                            </ion-chip>
                          }
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }
        }
      }
    }

    @if (energyWallet$ | async; as energyWallet) {
      <div class="review__section">
        <p class="review__label">{{ 'APP.INSTALLATION.BENEFITS.WALLET_TITLE' | translate }}</p>
        <div class="review__stat">
          <span class="review__stat-k">{{ 'APP.INSTALLATION.BENEFITS.WALLET_AVAILABLE_LABEL' | translate }}</span>
          <span class="review__stat-v">{{ formatKwh(energyWallet.availableWh) }}</span>
        </div>
      </div>
    }

    @if($tariffDeposit() && $tariffDeposit()>0){
    <div class="review__section">
      <p class="review__label">{{ 'INSTALLATION.DEPOSIT_PAYMENT' | translate }}</p>
      <div class="review__tariff">{{ "INSTALLATION.DEPOSIT_TOT" | translate: { deposit: $tariffDeposit().toFixed(2) } }}</div>
    </div>
    }
  </div>
  }

  @if ((currentStep$|async)===1) {
  <div>
    <div class="mt-8 centered-content">
      <img src="assets/images/illustrazione_ricarica.svg" alt="Charging illustration">
    </div>

    <div style="margin-top: 50px;">
      <ion-grid>
        <ion-row>
          <ion-col size="auto"><ion-chip class="fs-16 fw-600">1</ion-chip></ion-col>
          <ion-col><ion-text class="fs-16">{{ "APP.INSTALLATION.CHECK_YOU_ARE_USING_THE_DEVICE" | translate}} <b>{{
                mainStateService.$selectedStation()?.name }}</b></ion-text></ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="auto"><ion-chip class="fs-16 fw-600">2</ion-chip></ion-col>
          <ion-col><ion-text class="fs-16">{{ "APP.INSTALLATION.CHECK_YOU_ARE_USING_THE_CONNECTOR" | translate}} <b>{{
                mainStateService.$selectedConnector()?.name || mainStateService.$selectedConnector()?.cpConnectorId
                }}</b></ion-text></ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="auto"><ion-chip class="fs-16 fw-600">3</ion-chip></ion-col>
          <ion-col><ion-text class="fs-16">{{ "APP.INSTALLATION.INSERT_PLUG_AND_START_CHARGING_USING_THIS_BUTTON" |
              translate }}</ion-text></ion-col>
        </ion-row>
      </ion-grid>
    </div>

    @if (hostedAvailable()) {
    <div class="pay-method">
      <p class="review__label">{{ 'APP.INSTALLATION.HOSTED_PAY.METHOD_LABEL' | translate }}</p>
      <button type="button" class="pay-option" [class.pay-option--on]="(paymentMethod$ | async) === 'CARD'"
        [disabled]="(hostedPhase$ | async) !== 'idle'" (click)="selectPaymentMethod('CARD')">
        <ion-icon class="pay-option__i" name="card-outline"></ion-icon>
        <span class="pay-option__txt">
          <span class="pay-option__t">{{ 'APP.INSTALLATION.HOSTED_PAY.CARD_TITLE' | translate }}</span>
          <span class="pay-option__s">{{ 'APP.INSTALLATION.HOSTED_PAY.CARD_SUBTITLE' | translate }}</span>
        </span>
      </button>
      <button type="button" class="pay-option" [class.pay-option--on]="(paymentMethod$ | async) === 'HOSTED'"
        [disabled]="(hostedPhase$ | async) !== 'idle'" (click)="selectPaymentMethod('HOSTED')">
        <ion-icon class="pay-option__i" [name]="walletIcon()"></ion-icon>
        <span class="pay-option__txt">
          <span class="pay-option__t">{{ walletKey('TITLE') | translate }}</span>
          <span class="pay-option__s">{{ walletKey('SUBTITLE') | translate }}</span>
        </span>
      </button>
      @if ((hostedPhase$ | async) === 'paying') {
      <p class="pay-method__hint">{{ 'APP.INSTALLATION.HOSTED_PAY.PHASE_PAYING' | translate }}</p>
      }
    </div>
    }
  </div>
  }
</ion-content>

<ion-footer collapse="fade" class="ion-no-border ion-padding">
  @if ((currentStep$|async)===0) {
  <ion-button class="btn-yf" color="secondary" expand="block" (click)="showNextStep()"
    [disabled]="chargingBenefitsLoading$ | async">{{
    "BUTTONS.NEXT" | translate}}
    <ion-icon slot="end" src="assets/app-icons/arrow_forward.svg"></ion-icon>
  </ion-button>
  }

  @if ((currentStep$|async)===1){
  <ion-button class="btn-yf" color="secondary" expand="block" (click)="confirmOperation()"
    [disabled]="mainStateService.$connectorCommandInProgress() || (hostedPhase$ | async) !== 'idle'">
    @if((hostedPhase$ | async) !== 'idle'){
    <ion-spinner slot="start"></ion-spinner>
    <ion-label class="ion-align-items-center">{{ hostedPhaseLabel() }}</ion-label>
    }
    @else if(mainStateService.$connectorCommandInProgress()){
    <ion-spinner></ion-spinner>
    }
    @else {
    <ion-icon slot="start" src="assets/app-icons/ricarica.svg"></ion-icon>
    <ion-label class="ion-align-items-center"> {{ "APP.INSTALLATION.BUTTONS.START_CHARGING" | translate
      }}</ion-label>
    }
  </ion-button>
  }
</ion-footer>
